export default "__VITE_ASSET__DnAloAJF__"